module.exports = __webpack_public_path__ + "./images/Personal.67d68ac509f835cdfd33a6fe4c8b6c09.png";


//////////////////
// WEBPACK FOOTER
// ./websources/public/images/Personal.png
// module id = ./websources/public/images/Personal.png
// module chunks = 0